import React from "react";
import Typed from "react-typed";
import "./Home.css";
import "../Components/Header.css";
import { ImGithub } from "react-icons/im";
import { IoSend } from "react-icons/io5";
import { BsMouse } from "react-icons/bs";
import { BiDownArrowAlt } from "react-icons/bi";
import homePic from "../assets/Json/6_Targeting.json";
import Lottie from "lottie-react";

const Home = () => {
  return (
    <main className="main">
      {/* ==================== HOME ==================== */}
      <section className="home section" id="home">
        <div className="home__container container grid">
          <div className="home__content grid">
            <div className="home__social">
              <a
                href="https://github.com/PradipKhamkar"
                className="home__social-icon"
                target="_blank"
              >
                <i>
                  <ImGithub />
                </i>
              </a>
            </div>
            <div className="home__img">
              <Lottie animationData={homePic} />
              {/* <svg className="home__blob" viewBox="0 0 200 187">
                <mask id="mask0" mask-type="alpha">
                  <path
                    d="M190.312 36.4879C206.582 62.1187 201.309 102.826 182.328 134.186C163.346 165.547 
        130.807 187.559 100.226 186.353C69.6454 185.297 41.0228 161.023 21.7403 129.362C2.45775 
        97.8511 -7.48481 59.1033 6.67581 34.5279C20.9871 10.1032 59.7028 -0.149132 97.9666 
        0.00163737C136.23 0.303176 174.193 10.857 190.312 36.4879Z"
                  />
                </mask>
                <g mask="url(#mask0)">
                  <path
                    d="M190.312 36.4879C206.582 62.1187 201.309 102.826 182.328 134.186C163.346 
        165.547 130.807 187.559 100.226 186.353C69.6454 185.297 41.0228 161.023 21.7403 
        129.362C2.45775 97.8511 -7.48481 59.1033 6.67581 34.5279C20.9871 10.1032 59.7028 
        -0.149132 97.9666 0.00163737C136.23 0.303176 174.193 10.857 190.312 36.4879Z"
                  />
                  <image
                    className="home_blob-img"
                    href={myPic}
                    x="-15"
                    y="-50"
                  />
                </g>
              </svg> */}
            </div>
            <div className="home__data">
              <h1 className="home__title">
                Hi, I'am <br /> Pradip
                <span className="Hello__icon">👋</span>
              </h1>
              <h3 className="home__subtitle">
                <Typed
                  strings={[
                    "I'm a MERN Developer  ",
                    "Looking For Opportunity ",
                  ]}
                  typeSpeed={120}
                  backSpeed={50}
                  loop
                />
              </h3>

              <p className="home__description">
                A passionate Full Stack Software Developer 🚀
              </p>
              <a
                href="#contact"
                className="contact__btn__home button button--flex"
              >
                Say Hello{" "}
                <i className="button__icon send__icon">
                  <IoSend />
                </i>
              </a>
            </div>
          </div>
          <div className="home__scroll">
            <a href="#about" className="home__scroll-button button--flex">
              <i className="home__scroll-mouse">
                <BsMouse />
              </i>
              <span className="home__scroll-name">Scroll Down</span>
              <i className="home__scroll-arrow">
                <BiDownArrowAlt />
              </i>
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
